import api from 'api/instance';

const URL = `${process.env.REACT_APP_API_URL}`;

export type PickupKpiPayload = {
  countingDate: string;
  employees: number;
  processTime: {
    hours: number;
    minutes: number;
  };
};

/**
 * Updates pickup KPI data (counting date, employees, and process time)
 * @param payload - KPI data with pickup ID
 * @returns Promise with server response
 */
export const updatePickupKpi = async (
  payload: PickupKpiPayload & { _id: string },
) => {
  const { _id, ...kpiPayload } = payload;

  const { data } = await api.patch(
    `${URL}/pickup/edit-pickup-kpi/${_id}`,
    kpiPayload,
  );

  return data;
};
